// packages/shared-hooks/src/users/useReactivateUser.ts
// Spec §18, §14.4. POST /users/:id/reactivate with no body.
// Invalidates list + detail so the row flips to "Активен".
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserActivationResponseSchema, type UserActivationResponse } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

// WHY: backend returns `{ changed: boolean; user: User }` from this endpoint;
// see useDeactivateUser for the same drift fix. Aliased to the shared
// activation envelope so both endpoints share one source of truth.
export type ReactivateUserResult = UserActivationResponse;

export function useReactivateUser(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ReactivateUserResult, unknown, void>({
    mutationFn: () =>
      client.post<ReactivateUserResult>(
        `/users/${id}/reactivate`,
        undefined,
        {},
        UserActivationResponseSchema,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['users', 'list'] });
      qc.invalidateQueries({ queryKey: ['user', id] });
    },
  });
}
